var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHideFill = function SvgHideFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.688 232.107a322.816 322.816 0 0 1 421.632 37.12l237.013 242.73L794.197 703.66l104.406 104.405-90.454 90.453-682.666-682.666 90.453-90.454 106.752 106.667zm221.739 68.906a213.33 213.33 0 0 0-131.072 21.76l287.872 287.872a213.333 213.333 0 0 0-156.8-309.632M575.488 847.019a323.24 323.24 0 0 1-295.808-92.246L42.667 512l97.706-100.096z"
  })));
};
export default SvgHideFill;